import React, { useEffect, useState } from 'react';

import FormInput from 'Components/FormInput';
import useOrdersStore from 'Stores/Orders';
import Loader from 'Components/Loader';
import OrderItem from './OrderItem';

/* Style */
import './Orders.scss';

const SearchOrder = () => {
	const [query, setQuery] = useState('');
	const [searching, setSearching] = useState(false);
	const [hasSubmit, setHasSubmit] = useState(false);
	const [ordersSearched, setOrdersSearched] = useState([]);
	const { searchOrders } = useOrdersStore();

	const submitQuery = async () => {
		setSearching(true);
		setHasSubmit(false);
		console.log('Search with query : ', query);

		const response = await searchOrders(query);

		if (response.datas) {
			setOrdersSearched(response.datas);
		}

		setSearching(false);
		setHasSubmit(true);
	};

	const handleKeyPress = (e) => {
		if (e.keyCode === 13 || e.which === 13) {
			console.log('key press', e);
			submitQuery();
		}
	};

	useEffect(() => {
		setHasSubmit(false);
	}, [query]);

	return (
		<div className="App-Orders">
			<div className="App-Orders-Search-Page">
				<div className="search-header">
					<div className="input-component">
						<FormInput
							label="Rechercher une commande"
							placeholder="N° de commande ou email du client"
							value={query}
							setValue={setQuery}
							onKeyPress={handleKeyPress}
							autoComplete="off"
							withButton={{
								text: 'Rechercher',
								action: submitQuery,
								isLoading: searching
							}}
						/>
					</div>
				</div>

				<div className="orders-list">
					{ query && searching && <Loader /> }
					{ query && hasSubmit && ordersSearched?.length === 0 && (
						<p>Pas de commande trouvée pour ce numéro de commande</p>
					)}

					{ query && hasSubmit && ordersSearched?.length > 0 && (
						<div className="orders-bysenddate">
							<div className="orders-header">Commandes trouvées avec le numéro #{query}</div>
							{ ordersSearched.map((order) => (
								<OrderItem
									key={order.id}
									order={order}
								/>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SearchOrder;
